module.exports = new __parcel__URL__("insight-object-view-attributes-skeleton.tpl.06a118aa.svg").toString();